import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import * as React from 'react';

var Container = _styled("div", true ? {
  target: "e16cmbub1"
} : {
  target: "e16cmbub1",
  label: "Container"
})(true ? {
  name: "2s18z6",
  styles: "display:inline-block;margin-right:8px;border:1px solid #e84545;box-sizing:border-box;border-radius:20px;padding:5px 16px 5px 16px"
} : {
  name: "2s18z6",
  styles: "display:inline-block;margin-right:8px;border:1px solid #e84545;box-sizing:border-box;border-radius:20px;padding:5px 16px 5px 16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvYXBwcy9mcm9udGVuZC9zcmMvY29udGFpbmVycy9Qb2xscy9jb21wb25lbnRzL0JhZGdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEIiLCJmaWxlIjoiL3ZlcmNlbC9wYXRoMC9hcHBzL2Zyb250ZW5kL3NyYy9jb250YWluZXJzL1BvbGxzL2NvbXBvbmVudHMvQmFkZ2UudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgKiBhcyBSZWFjdCBmcm9tICdyZWFjdCdcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBtYXJnaW4tcmlnaHQ6IDhweDtcbiAgYm9yZGVyOiAxcHggc29saWQgI2U4NDU0NTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgYm9yZGVyLXJhZGl1czogMjBweDtcbiAgcGFkZGluZzogNXB4IDE2cHggNXB4IDE2cHg7XG5gXG5cbmNvbnN0IFRpdGxlID0gc3R5bGVkLmRpdmBcbiAgZm9udC1zaXplOiAxMHB4O1xuYFxuaW50ZXJmYWNlIFByb3BzIHtcbiAgdGV4dDogc3RyaW5nXG4gIGNvbG9yOiBzdHJpbmdcbn1cbmNvbnN0IEJhZGdlOiBSZWFjdC5GQzxQcm9wcz4gPSAoeyB0ZXh0LCBjb2xvciB9KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBzdHlsZT17eyBib3JkZXJDb2xvcjogY29sb3IgfX0+XG4gICAgICA8VGl0bGUgc3R5bGU9e3sgY29sb3I6IGNvbG9yIH19Pnt0ZXh0fTwvVGl0bGU+XG4gICAgPC9Db250YWluZXI+XG4gIClcbn1cblxuZXhwb3J0IGRlZmF1bHQgQmFkZ2VcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var Title = _styled("div", true ? {
  target: "e16cmbub0"
} : {
  target: "e16cmbub0",
  label: "Title"
})(true ? {
  name: "ot4ncn",
  styles: "font-size:10px"
} : {
  name: "ot4ncn",
  styles: "font-size:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvYXBwcy9mcm9udGVuZC9zcmMvY29udGFpbmVycy9Qb2xscy9jb21wb25lbnRzL0JhZGdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZd0IiLCJmaWxlIjoiL3ZlcmNlbC9wYXRoMC9hcHBzL2Zyb250ZW5kL3NyYy9jb250YWluZXJzL1BvbGxzL2NvbXBvbmVudHMvQmFkZ2UudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgKiBhcyBSZWFjdCBmcm9tICdyZWFjdCdcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBtYXJnaW4tcmlnaHQ6IDhweDtcbiAgYm9yZGVyOiAxcHggc29saWQgI2U4NDU0NTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgYm9yZGVyLXJhZGl1czogMjBweDtcbiAgcGFkZGluZzogNXB4IDE2cHggNXB4IDE2cHg7XG5gXG5cbmNvbnN0IFRpdGxlID0gc3R5bGVkLmRpdmBcbiAgZm9udC1zaXplOiAxMHB4O1xuYFxuaW50ZXJmYWNlIFByb3BzIHtcbiAgdGV4dDogc3RyaW5nXG4gIGNvbG9yOiBzdHJpbmdcbn1cbmNvbnN0IEJhZGdlOiBSZWFjdC5GQzxQcm9wcz4gPSAoeyB0ZXh0LCBjb2xvciB9KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPENvbnRhaW5lciBzdHlsZT17eyBib3JkZXJDb2xvcjogY29sb3IgfX0+XG4gICAgICA8VGl0bGUgc3R5bGU9e3sgY29sb3I6IGNvbG9yIH19Pnt0ZXh0fTwvVGl0bGU+XG4gICAgPC9Db250YWluZXI+XG4gIClcbn1cblxuZXhwb3J0IGRlZmF1bHQgQmFkZ2VcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var Badge = function Badge(_ref) {
  var text = _ref.text,
      color = _ref.color;
  return _jsx(Container, {
    style: {
      borderColor: color
    },
    children: _jsx(Title, {
      style: {
        color: color
      },
      children: text
    })
  });
};

export default Badge;